import React from 'react';
import { View } from '@shared/components/View';
import { MBTextBody1 } from '@shared/components/typography';
import { i18n } from '@shared/util/i18n';

export function NeedsCardFilter() {
  return (
    <View centerHorizontally centerVertically marginHorizontal={2} marginVertical={4}>
      <MBTextBody1>{i18n('builder.relatedCardOptions.needsLinking')}</MBTextBody1>
    </View>
  );
}
